import { render } from "./ErrorPopup.vue?vue&type=template&id=dc000186&scoped=true&ts=true"
import script from "./ErrorPopup.vue?vue&type=script&lang=ts"
export * from "./ErrorPopup.vue?vue&type=script&lang=ts"

import "./ErrorPopup.vue?vue&type=style&index=0&id=dc000186&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc000186"]])

export default __exports__